import ServiceCategoryPage from "../components/ServiceCategoryPage";
import waterPurifierRepairService from "../data/services/waterPurifierRepairService";

function WaterPurifierRepair() {
  return <ServiceCategoryPage service={waterPurifierRepairService} />;
}

export default WaterPurifierRepair;